import { IMapCoordinates, IMapGeoObject } from '@cian/frontend-newbuilding-map-component';
import { IMainPromoPin } from '../../../../types/newbuilding/mainPromoPin';
import { getGeoObject } from '../index';

export function getMainGeoObject(pinCoordinates: IMapCoordinates, mainPromoPin: IMainPromoPin | null): IMapGeoObject {
  return getGeoObject({
    name: 'main',
    coordinates: pinCoordinates,
    id: '#newbuilding',
    mainPromoPin,
  });
}
